export enum DigitalSignageOrientation {
  unselected = '',
  horizontal = '0',
  vertical = '90',
  horizontalInverted = '180',
  verticalInverted = '270',
}

export enum DigitalSignageCardType {
  DEVICE = 'device',
  SIGNAGE = 'signage',
}

export enum DigitalSignageDeleteMessage {
  DELETE_DEVICE = 'Are you sure you want to delete the device? This cannot be reversed.',
  DELETE_SIGNAGE = 'Deleting the signage will remove it from any associated devices. Are you sure you want to delete the signage? This cannot be reversed.',
}

export enum DigitalSignageAPIState {
  DEFAULT = 'default',
  FETCHING_SIGNAGES = 'fetching_signages',
  FETCHING_DEVICES = 'fetching_devices',
  DELETING_SIGNAGE = 'deleting_signage',
  DELETING_DEVICE = 'deleting_device',
}
